{% block sw_category_tree_items %}
    <template
        #items="{
            treeItems,
            sortable,
            draggedItem,
            newElementId,
            translationContext,
            onChangeRoute,
            disableContextMenu
        }">
        <sw-tree-item
            v-for="item in treeItems"
            :key="item.id"
            :item="item"
            :active="item.active"
            :translationContext="translationContext"
            :onChangeRoute="clickItem"
            :sortable="sortable"
            :draggedItem="draggedItem"
            :disableContextMenu="disableContextMenu"
            :newElementId="newElementId"
            @check-item="checkItem">
        </sw-tree-item>
    </template>
{% endblock %}

